import { BACKEND_URL, INITIAL_PAGE_URL } from "../Config"
import { Cookies } from 'react-cookie';
import { Navigate  } from "react-router-dom";

export const basePort = BACKEND_URL

export const headers = {
    'Accept': 'application/json, text/plain',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': "Origin, X-Requested-With, Access-Control-Allow-Headers, Content-Type, Authorization",
    'Allow-Control-Allow-Methods': "GET, POST, OPTIONS",
}

export const multipartHeaders = {
  'Accept': 'application/json, text/plain',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Headers': "Origin, X-Requested-With, Access-Control-Allow-Headers, Content-Type, Authorization",
  'Allow-Control-Allow-Methods': "GET, POST, OPTIONS",
}

export const headersTest = {
  'Accept': 'application/json, text/plain',
  'Content-Type': 'application/json',
}

export const openHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Headers': "Origin, X-Requested-With, Access-Control-Allow-Headers, Content-Type, Authorization",
  'Allow-Control-Allow-Methods': "GET, POST, OPTIONS",
}

export function setTokenHeader(token){
  headers['Authorization'] = 'Bearer ' + token;
}

export function setMutipartTokenHeader(token){
  multipartHeaders['Authorization'] = 'Bearer ' + token;
}

export function validToken(token){
  return token === "" ? false : true
}

export function getEmptyPage(){
  return ""
}

export const INITIAL_PAGE = INITIAL_PAGE_URL

export function parseJwt(token) {
  if (!token) { return; }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
}

export function getUsernameJwt(token) {
  if (!token) { return; }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64)).sub;
}

export function getRoleJwt(token) {
  if (!token) { return; }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64)).Roles[0].authority;
}

export function IsMbrRoleCP(token) {
  const mbrTyp = getRoleJwt(token)
  if(mbrTyp === "ROLE_CP"){
    return true;  
  } else {
    return false;
  }
}

export function IsMbrRolePv(token) {
  const mbrTyp = getRoleJwt(token)
  if(mbrTyp === "ROLE_PV"){
    return true;  
  } else {
    return false;
  }
}

export function IsMbrRoleAdmin(token) {
  const mbrTyp = getRoleJwt(token)
  if(mbrTyp === "ROLE_ADMIN"){
    return true;  
  } else {
    return false;
  }
}

export function IsMbrTempRole(token) {
  const mbrTyp = getRoleJwt(token)
  if(mbrTyp === "ROLE_TEMP_CP" || mbrTyp === "ROLE_TEMP_PV"){
    return true;  
  } else {
    return false;
  }
}

export function isExpiredJwt(token) {
  if (!token) { return; }
  var isExpired = false;
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  var dateNow = new Date();
  var decodedToken = JSON.parse(window.atob(base64))
  if(decodedToken.exp < Math.floor(dateNow.getTime()/1000)) {
    isExpired = true;
  }
  return isExpired;
}

export const cookies = new Cookies()

export function getJwtFromCookies() {
  return cookies.get("token");
}

export function removeCookies() {
  cookies.remove('token');
}

export function setCookie(value){
  cookies.set("token", value, { path: '/' });
  console.log("setCookie:" + cookies.get("token"))
}

export function renderRedirect(redirect, url) {
  if (redirect) {
    // return <Navigate to='/login' />
    //url
    return <Navigate to={url} />
  }
}

export const queryParameters = new URLSearchParams(window.location.search)